var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7149 7.98L16.0349 3.3C15.8449 3.11 15.5849 3 15.3249 3H8.68488C8.42488 3 8.16488 3.11 7.98488 3.29L3.29488 7.98C3.11488 8.16 3.00488 8.42 3.00488 8.68V15.31C3.00488 15.58 3.11488 15.83 3.29488 16.02L7.97488 20.7C8.16488 20.89 8.42488 21 8.68488 21H15.3149C15.5849 21 15.8349 20.89 16.0249 20.71L20.7049 16.03C20.8949 15.84 20.9949 15.59 20.9949 15.32V8.68C21.0049 8.42 20.8949 8.16 20.7149 7.98ZM19.0049 14.9L14.9049 19H9.10488L5.00488 14.9V9.1L9.10488 5H14.9049L19.0049 9.1V14.9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0049 17C12.5572 17 13.0049 16.5523 13.0049 16C13.0049 15.4477 12.5572 15 12.0049 15C11.4526 15 11.0049 15.4477 11.0049 16C11.0049 16.5523 11.4526 17 12.0049 17Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0049 7C11.4549 7 11.0049 7.45 11.0049 8V13C11.0049 13.55 11.4549 14 12.0049 14C12.5549 14 13.0049 13.55 13.0049 13V8C13.0049 7.45 12.5549 7 12.0049 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.bb522c171a2e01e87fc612ed52653276.svg";
export { ForwardRef as ReactComponent };